import { MotorcycleIcon } from "./icons/VehicleIcons";

/**
 * Einheitliches Marken-Logo (Jun-2026 · User-Wunsch): dunkles Quadrat mit
 * Motorrad-Symbol + Schriftzug two(weiß im Dark-Mode)/wheels(orange)/.de.
 * Überall identisch verwenden, damit alle Logos gleich aussehen.
 * `className="contents"` einsetzen, wenn das Logo in einem bestehenden
 * Flex-Wrapper (z. B. <Link>) flach einfließen soll.
 */
export default function Logo({
    className = "inline-flex items-center gap-2",
    boxClass = "w-10 h-10",
    iconClass = "w-6 h-6",
    textClass = "text-2xl",
    deClass = "text-black/60",
}) {
    return (
        <span className={className} data-testid="brand-logo">
            <span className={`${boxClass} logo-box flex items-center justify-center rounded-sm shrink-0`}>
                <MotorcycleIcon className={`${iconClass} logo-bike`} strokeWidth={2} />
            </span>
            <span className={`font-display ${textClass} font-black tracking-tight leading-none`}>
                <span className="logo-two">two</span><span className="logo-wheels">wheels</span><span className={`${deClass} logo-de`}>.info</span>
            </span>
        </span>
    );
}
